import { ReduxProvider } from './ReduxProvider';
import { ThemeProvider } from './ThemeProvider';
import { AuthProvider } from '@/context/AuthContext';
import { ToastContainer } from '@/components/common/ToastContainer';
import { ConfirmProvider } from '@/components/common/ConfirmDialog/ConfirmProvider';
import { OperationalDashboardAccessProvider } from '@/features/operationalDashboard/context/OperationalDashboardAccessProvider';

/**
 * Composed application providers.
 * Order matters: Redux first (ThemeProvider reads Redux), then Auth.
 *
 * @example
 * // In main.jsx
 * <AppProviders>
 *   <AppRouter />
 * </AppProviders>
 */
export function AppProviders({ children }) {
    return (
        <ReduxProvider>
            <ThemeProvider>
                <AuthProvider>
                    <OperationalDashboardAccessProvider>
                        <ConfirmProvider>
                            {children}
                            <ToastContainer />
                        </ConfirmProvider>
                    </OperationalDashboardAccessProvider>
                </AuthProvider>
            </ThemeProvider>
        </ReduxProvider>
    );
}

export default AppProviders;
